
export default class Model {
    // 重新计算当前页
    public async recalculateCurrent (pageBean: any){
        if (pageBean.pages > 1) {
            const yushu = pageBean.total % pageBean.size;
            // 余数为1说明是，本页只有一条记录，current大于1的判断是：只有当前页大于第一页，才执行
            if (yushu === 1 && pageBean.current>1) {
            --pageBean.current;
            }
        }
    }

    // 获取当前用户的对象，有id、username属性
    public getMyuser (){
        const myuserStr: any = localStorage.getItem('myuser');
        const myuser: any = JSON.parse(myuserStr);
        return myuser;
    }
    
}